// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"31194666de2bdfb7","5763":"63a365673b81020c","6893":"3d389c0e5e51d301","6974":"12b8e9df7f70a482","7222":"2bef54495d152c9a","7937":"4865ffe2da3e63fd"}[chunkId] + ".js";
};